import React from 'react';
import PropTypes from 'prop-types';
import NoticeBox from '@/components/organisms/NoticeBox';

const DlgBenefitLightComponent = ({ glyph, title, content, link }) => (
  <NoticeBox
    glyph={glyph}
    title={title}
    subTitle={content}
    linkName={link.name}
    linkUrl={link.url}
    modifiers={['light']}
    linkTarget={link.target}
  />
);

DlgBenefitLightComponent.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  glyph: PropTypes.string,
  link: PropTypes.shape({
    url: PropTypes.string,
    name: PropTypes.string,
    target: PropTypes.string,
  }),
};

DlgBenefitLightComponent.defaultProps = {
  title: null,
  content: null,
  glyph: null,
  link: {},
};

export default DlgBenefitLightComponent;
